import Markdown from "markdown-to-jsx";
import StepCards from 'components/pages/CasaVerdeAmarela/StepCards'
import Image from 'next/image'
import styles from "./vocacao.module.css";


export default function Passos({ data }) {
  return (
    <>
      <section className={`container-full`}>
        <div className={`flex-column flex-lg-row ${styles.content}`}>
          <div className={styles.title}>
            <div className={styles.parallelogramDetail} />
            <h2>{data.titulo}</h2>
          </div>
          <div className={styles.descricao}>
            <div className={styles.markContent}>
              <Markdown>{data.descricao}</Markdown>
            </div>
            <div className={styles.cardsContent}>
              {
                data.passos_list.map((item, index) => {
                  return (
                    <StepCards data={item} />
                  )
                })
              }
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
